<template>
  <div class="common-table" :class="{ 'common-table--elevated': is_table }">
    <div
      class="common-table__toolbar"
      v-if="enableAdd || enableSearch"
      :class="{ 'common-table__toolbar--elevated': is_table }"
    >
      <div class="common-table__search">
        <el-form
          v-if="enableSearch"
          ref="search"
          @submit.native.prevent
          :model="formValue"
          size="small"
          class="common-table__search-form"
        >
          <el-row class="common-table__search-grid">
            <el-col
              v-for="item in searchItems"
              :key="item.key || item.label"
              :span="item.span || 6"
              :offset="item.offset || 0"
              class="common-table__query-item"
            >
              <el-form-item
                class="common-table__form-item"
                label-position="left"
                :label="item.label"
                label-width="70px"
              >
                <el-select
                  v-if="
                    item.type == 'select' ||
                    (item.options && item.type != 'selectgroup')
                  "
                  v-model="item.value"
                  @change="handleChange"
                  size="small"
                  filterable
                >
                  <el-option
                    v-for="op in item.options"
                    :key="op.key || op.value"
                    :label="op.label"
                    :value="op.value"
                  ></el-option>
                </el-select>
                <el-select
                  v-if="item.type == 'selectgroup'"
                  v-model="item.value"
                  @change="handleChange"
                  size="small"
                  filterable
                >
                  <el-option-group
                    v-for="group in item.options"
                    :key="group.label"
                    :label="group.label"
                  >
                    <el-option
                      v-for="item in group.options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-option-group>
                </el-select>
                <el-input
                  v-if="item.type == 'input'"
                  v-model="item.value"
                  size="small"
                  @keyup.enter.native="handleChange"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="handleChange"
                  ></el-button>
                </el-input>
                <el-date-picker
                  v-if="item.type == 'timerange'"
                  class="zslFormtime"
                  size="small"
                  type="datetimerange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="handleChange"
                  :default-time="['00:00:00', '23:59:59']"
                  v-model="item.value"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="common-table__actions" v-if="enableAdd">
        <el-button
          class="common-table__add-button"
          size="small"
          v-permit="addPerm"
          @click="onAdd"
          type="primary"
        >
          {{ addTitle ? addTitle : '新增' }}
        </el-button>
      </div>
    </div>
    <div
      class="common-table__content"
      :class="{ 'common-table__content--elevated': is_table }"
    >
      <el-table
        class="common-table__table"
        :data="tableData"
        v-loading="loading"
        header-cell-class-name="common-table__header-cell"
        id="zsltable"
        :style="{ width: '100%' }"
      >
        <template slot="empty" v-if="emptyStatus">
          <div class="common-table__empty">
            <div class="common-table__empty-icon">
              <i class="el-icon-document"></i>
            </div>
            <p class="common-table__empty-title">当前列表为空</p>
            <p class="common-table__empty-desc">
              您还没有可以上架的应用。点击
              <a
                href="https://www.rainbond.com/docs/store/onLine/aindex"
                target="_blank"
              >
                《文档》
              </a>
              ，查看如何制作并上线应用。
            </p>
          </div>
        </template>
        <template v-for="(item, index) in column">
          <el-table-column
            :key="index"
            :width="item.width ? item.width : 'auto'"
            :min-width="item.minWidth"
            :prop="item.prop"
            :align="item.align ? item.align : 'center'"
            :label="item.label"
            :fixed="item.fixed ? item.fixed : false"
          >
            <template slot-scope="scope">
              <slot
                v-if="item.scopeStatus"
                :name="item.prop"
                :row="scope.row"
              ></slot>
              <template v-else>{{ scope.row[item.prop] }}</template>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <div class="common-table__pagination" v-if="PageInfo">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="PageInfo.page"
        :page-size="PageInfo.pageSize"
        :page-sizes="[5, 10, 15]"
        layout="total, sizes,prev, pager, next,jumper"
        :total="PageInfo.total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    handlePaginationChange: Function,
    onAdd: Function,
    enableSearch: Boolean,
    is_table: Boolean,
    addTitle: String,
    addPerm: String,
    loading: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array
    },
    searchItems: {
      type: Array
    },
    column: {
      type: Array
    },
    PageInfo: {
      type: Object
    },
    emptyStatus: Boolean
  },
  data() {
    return {
      formValue: {}
    };
  },

  watch: {
    searchItems(value) {}
  },
  computed: {
    enableAdd() {
      if (this.onAdd) {
        return true;
      }
      return false;
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit('handlePaginationChange', { page: val });
    },
    handleSizeChange(val) {
      this.$emit('handlePaginationChange', { pageSize: val });
    },
    handleChange() {
      const queryItem = {};
      this.searchItems.map((item) => {
        if (Array.isArray(item.name)) {
          for (let i = 0; i < item.name.length; i++) {
            if (!item.value) {
              item.value = '';
            }
            queryItem[item.name[i]] = this.handleTrim(
              item.value ? item.value[i] : ''
            );
          }
        } else {
          queryItem[item.name] = this.handleTrim(item.value || '');
        }
      });
      queryItem.page = 1;
      this.$emit('handlePaginationChange', queryItem);
    },
    handleTrim(str) {
      if (str && typeof str == 'string') {
        return str.trim();
      }
      return str || '';
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.common-table {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.common-table__toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 18px 20px;
  border: 1px solid rgba(209, 221, 233, 0.92);
  border-radius: 22px;
  background:
    linear-gradient(180deg, rgba(249, 252, 255, 0.96) 0%, rgba(242, 247, 251, 0.94) 100%);
}

.common-table__search {
  flex: 1;
}

.common-table__search-form {
  position: relative;
}

.common-table__search-grid {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 14px;
  margin: 0 -9px;
}

.common-table__query-item {
  min-width: 220px;
  padding: 0 9px;
  margin-left: 0 !important;
}

.common-table__actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  align-self: flex-start;
  min-width: 144px;
  padding-top: 0;
}

.common-table__content {
  overflow: hidden;
  border: 1px solid rgba(212, 223, 234, 0.94);
  border-radius: 24px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(249, 252, 255, 0.98) 100%);
}

.common-table__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 42px 20px;
  text-align: center;
  color: var(--shell-text-muted, #6c7d92);
  line-height: 1.7;
}

.common-table__empty-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-bottom: 14px;
  border-radius: 18px;
  background: linear-gradient(180deg, #eef4fb 0%, #e4edf7 100%);
  color: #5f7f9f;
  font-size: 24px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.95);
}

.common-table__empty-title {
  margin: 0 0 6px;
  color: #304659;
  font-size: 16px;
  font-weight: 700;
}

.common-table__empty-desc {
  max-width: 520px;
  margin: 0;
}

.common-table__empty a {
  color: #4d8ac5;
  font-weight: 600;
}

.common-table__pagination {
  display: flex;
  justify-content: flex-end;
  padding: 0 4px;
}

.common-table__add-button {
  min-width: 112px;
  height: 44px;
  padding: 0 20px;
  border: 0;
  border-radius: 14px;
  background: linear-gradient(135deg, #4f85bb 0%, #3c6f9f 100%);
  color: #ffffff;
  font-weight: 700;
  letter-spacing: 0.01em;
  box-shadow: 0 12px 22px rgba(63, 111, 159, 0.2);
}

.common-table__add-button:hover,
.common-table__add-button:focus {
  background: linear-gradient(135deg, #467caf 0%, #35638e 100%);
  transform: translateY(-1px);
  box-shadow: 0 16px 26px rgba(53, 99, 142, 0.24);
}

::v-deep .common-table__form-item.el-form-item--small {
  margin-bottom: 0 !important;
}

::v-deep .common-table__form-item .el-form-item__label {
  color: #5b6f83;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
}

::v-deep .common-table__form-item .el-form-item__content {
  line-height: normal;
}

::v-deep .common-table__form-item .el-select {
  width: 100%;
}

::v-deep .common-table__form-item .el-input__inner,
::v-deep .common-table__form-item .el-range-editor.el-input__inner {
  height: 44px;
  border: 1px solid rgba(205, 217, 229, 0.96);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.96);
  color: var(--shell-text-primary, #1d2b3d);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.96),
    0 4px 10px rgba(84, 109, 136, 0.04);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

::v-deep .common-table__form-item .el-input__inner::placeholder,
::v-deep .common-table__form-item .el-range-input::placeholder {
  color: #97a6b7;
}

::v-deep .common-table__form-item .el-input__inner:hover,
::v-deep .common-table__form-item .el-range-editor.el-input__inner:hover {
  border-color: rgba(165, 181, 197, 0.96);
  background: #ffffff;
}

::v-deep .common-table__form-item .el-input.is-focus .el-input__inner,
::v-deep .common-table__form-item .el-range-editor.is-active,
::v-deep .common-table__form-item .el-range-editor.is-active:hover {
  border-color: rgba(77, 138, 197, 0.82);
  box-shadow:
    0 0 0 4px rgba(77, 138, 197, 0.12),
    0 10px 18px rgba(77, 138, 197, 0.08);
}

::v-deep .common-table__form-item .el-input-group__append {
  border: 1px solid rgba(205, 217, 229, 0.96);
  border-left: 0;
  border-radius: 0 14px 14px 0;
  background: linear-gradient(180deg, #f4f7fa 0%, #ecf1f6 100%);
  color: #62768b;
}

::v-deep .common-table__form-item .el-input-group__append .el-button {
  color: inherit;
}

::v-deep .common-table__form-item .el-input__icon,
::v-deep .common-table__form-item .el-range__icon,
::v-deep .common-table__form-item .el-range__close-icon {
  color: #8aa0b6;
}

::v-deep .common-table__table {
  background: transparent;
}

::v-deep .common-table__table:before {
  display: none;
}

::v-deep .common-table__table th {
  padding: 16px 0;
  background: linear-gradient(180deg, #f7fafd 0%, #eff4f8 100%) !important;
  color: #607487 !important;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  border-bottom: 1px solid rgba(216, 225, 234, 0.96);
}

::v-deep .common-table__table td {
  padding: 17px 0;
  color: var(--shell-text-primary, #1d2b3d);
  background: transparent;
  border-bottom: 1px solid rgba(231, 237, 243, 0.96);
  transition: background-color 0.2s ease;
}

::v-deep .common-table__table th .cell,
::v-deep .common-table__table td .cell {
  padding: 0 18px;
  line-height: 1.5;
}

::v-deep .common-table__table th .cell {
  font-weight: 700;
}

::v-deep .common-table__table .el-table__row:last-child td {
  border-bottom: 0;
}

::v-deep .common-table__table .el-table__row:hover > td {
  background: rgba(244, 249, 253, 0.96) !important;
}

::v-deep .common-table__table .el-table__row:hover > td:first-child .cell {
  color: #20415f;
}

::v-deep .common-table__table .el-table__fixed,
::v-deep .common-table__table .el-table__fixed-right {
  box-shadow: none;
}

::v-deep .common-table__table .el-table__fixed::before,
::v-deep .common-table__table .el-table__fixed-right::before {
  display: none;
}

::v-deep .common-table__table .el-table__fixed th,
::v-deep .common-table__table .el-table__fixed-right th {
  background: linear-gradient(180deg, #f7fafd 0%, #eff4f8 100%) !important;
}

::v-deep .common-table__table .el-table__fixed td,
::v-deep .common-table__table .el-table__fixed-right td {
  background: rgba(255, 255, 255, 0.98);
}

::v-deep .common-table__table .el-button--text {
  padding: 0;
  color: #3d6f9f;
  font-weight: 600;
  transition: color 0.2s ease, opacity 0.2s ease;
}

::v-deep .common-table__table .el-button--text:hover,
::v-deep .common-table__table .el-button--text:focus {
  color: #2f5d89;
  opacity: 1;
}

::v-deep .common-table__table .el-button--text + .el-button--text {
  margin-left: 14px;
}

::v-deep .common-table__table .el-tag {
  padding: 0 10px;
  height: 26px;
  line-height: 24px;
  border-radius: 999px;
  border-color: rgba(187, 204, 219, 0.74);
  background: linear-gradient(180deg, #f7fafc 0%, #edf3f8 100%);
  color: #556a7f;
  font-weight: 600;
}

::v-deep .common-table__pagination .el-pagination {
  padding: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

::v-deep .common-table__pagination .el-pagination__total,
::v-deep .common-table__pagination .el-pagination__jump {
  color: #667b91;
  font-weight: 500;
}

::v-deep .common-table__pagination .el-pagination__sizes .el-input .el-input__inner,
::v-deep .common-table__pagination .el-pagination__jump .el-input__inner {
  height: 34px;
  border-radius: 10px;
  border-color: rgba(205, 217, 229, 0.96);
  background: #f7fafc;
}

::v-deep .common-table__pagination .btn-next,
::v-deep .common-table__pagination .btn-prev,
::v-deep .common-table__pagination .el-pager li {
  min-width: 34px;
  height: 34px;
  line-height: 34px;
  background: linear-gradient(180deg, #f7fafc 0%, #edf3f8 100%);
  color: #617286;
  border-radius: 10px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.92);
}

::v-deep .common-table__pagination .el-pager li.active {
  background: linear-gradient(135deg, #4f85bb 0%, #3c6f9f 100%);
  color: #ffffff;
  box-shadow: 0 8px 16px rgba(60, 111, 159, 0.2);
}

::v-deep .common-table__pagination .btn-next:hover,
::v-deep .common-table__pagination .btn-prev:hover,
::v-deep .common-table__pagination .el-pager li:hover {
  color: #355d86;
}

::v-deep .common-table__table .el-table__empty-block {
  min-height: 220px;
}

::v-deep .common-table__table .el-table__empty-text {
  color: #6f8195;
}

@media (max-width: 992px) {
  .common-table__toolbar {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
  }

  .common-table__actions {
    width: 100%;
    align-self: auto;
    justify-content: flex-start;
    padding-top: 0;
  }
}

@media (max-width: 768px) {
  .common-table__toolbar {
    padding: 14px;
  }

  .common-table__query-item {
    min-width: 100%;
  }

  .common-table__content {
    border-radius: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PublicTable/index.vue